export enum WINDOW_NAMES {
  RunDialog = "run-dialog-modal",
  AboutMe = "about-modal",
  QuestLog = "quest-modal",
  RegistryEditor = "registry-editor-modal",
  AboutProjects = "about-projects-modal",
  ChatClient = "chat-client-modal",
  NetworkStatus = "network-status-modal",
  MailClient = "mail-client-modal",
  WebAmp = "webamp-modal",
  InternetClient = "internet-client-modal",
  SystemProperties = "system-properties-modal",
  UserInfo = "user-info-modal",
}
